import { render, staticRenderFns } from "./version-list.vue?vue&type=template&id=60d05bc8&scoped=true&"
import script from "./version-list.vue?vue&type=script&lang=ts&"
export * from "./version-list.vue?vue&type=script&lang=ts&"
import style0 from "./version-list.vue?vue&type=style&index=0&id=60d05bc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d05bc8",
  null
  
)

export default component.exports